import AppConfirmationDialog from '../../../../../../components/common/AppConfirmationDialog';
import {SVG} from '../../../../../../constants/assetLists';

type TreeDeleteConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

function TreeDeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
}: TreeDeleteConfirmationDialogProps) {
  return (
    <AppConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="הודעת מחיקה"
      subTitle={
        <div className="flex flex-col gap-1">
          <p className="m-0">
            מחיקת הענף תמחק את כל התוכן שהוספת בו; לא ניתן לבטל פעולה זו.
          </p>
          <p className="m-0">אתה בטוח?</p>
        </div>
      }
      icon={
        <img
          src={SVG.listDeleteRedIcon}
          alt="delete"
          className="w-[48px] h-[48px]"
        />
      }
      containerClasses="!px-[0]"
      buttonsClass="!gap-5"
      confirmBtnText="כן"
      cancelBtnText="לא"
      confirmBtnTextClasses="!text-white !bg-tealBlue !px-8 !py-1 !rounded-full"
      cancelBtnTextClasses="!text-[#1D1B20] !bg-white !border !border-[#B8B8B8] !px-8 !py-1 !rounded-full"
      bordered={false}
      width={350}
    />
  );
}

export default TreeDeleteConfirmationDialog;
